<template>
  <header>
    <MenuStacked />

    <Logotype />

    <Responsive v-slot="{ breakpoint }">
      <MenuNavigation v-if="breakpoint === 'wide'" />
    </Responsive>

    <div class="nav-right">
      <LanguageNavigation />

      <Responsive v-slot="{ breakpoint }">
        <MenuToggle
          v-if="breakpoint !== 'wide'"
          :open="showMenu > 0"
          @click="showMenu = showMenu > 0 ? 0 : 1"
        />
      </Responsive>
    </div>

  </header>
</template>

<script setup>
import { useStore } from '@/KQL.js'
import { pageFromPath } from '@/utils'
import { composables } from '@/composables'
import { computed } from 'vue'

const kql = useStore()
const showMenu = composables().showMenu
const home = computed(() => pageFromPath('home', kql.pages))
</script>

<style scoped>
header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 2;
  display: flex;
  justify-content: space-between;
  align-items: strech;
  width: var(--main-width-narrow);
  margin: auto;
  padding: var(--header-padding);
}

.nav-right {
  display: flex;
  align-items: center;
  gap: 1rem;
}
</style>
